import React, { useEffect, useState } from "react";
import { Box, CssBaseline, Grid, Typography } from "@mui/material";
import { mainLayoutStyles, showNotification } from "../../../../../constants";

import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import DetailsPageHeader from "../../../../../common/DetailsPageHeader";
import { Toast } from "../../../../../common/alert";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";
import {
  addClarifai,
  getClarifaiData,
  updateClarifai,
} from "../../hooks/ThirdPartyToolsHook";

const AdminUsersContainer = () => {
  // const [filterModal, setFilterModal] = useState(false);
  // const [filterOptions, setFilterOptions] = useState([]);
  const [editEnabled, setEditEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clarifaiData, setClarifaiData] = useState({
    snapshotsFrequency: "",
    displayListScore: "",
    directPlayScore: "",
    timeLimit: "",
  });

  useEffect(() => {
    handleGetClarifaiData();
  }, []);

  const handleGetClarifaiData = async () => {
    try {
      let tempData = await getClarifaiData();
      setClarifaiData(tempData);
      console.log("clarifai data:", tempData)
    } catch (error) {
      console.log("error getting clarifai data:", error.message);
    }
  };

  const handleSaveClarifai = async () => {
    try {
      setLoading(true);
      let temp = {
        ...clarifaiData,
        updatedAt: new Date(),
      };
      delete temp.createdAt;
      delete temp.id;
      let responseTemp = await updateClarifai(clarifaiData?.id, temp);
      await handleGetClarifaiData()
      // let responseTemp = await addClarifai(temp);
      showNotification("Visual Search settings updated successfully.");
      setEditEnabled(false); // Exit edit mode after successful save
    } catch (error) {
      console.log("error updating clarify settings:", error.message);
      Toast("error", "error updating clarify settings");
    } finally {
      setLoading(false);
    }
  };

  // const [selected, setSelected] = useState([]);
  // const handleFilterModalOpen = () => {
  //   setFilterModal(true);
  // };
  // const handleFilterModalClose = () => {
  //   setFilterModal(false);
  // };

  // const resetFilter = async () => {
  //   setFilterOptions([]);
  // };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {/* <Header
        mainTitle={"3rd Party Tools"}
        bgColor="#fff"
        buttonText={"Add User"}
        editEnabled={editEnabled}
        setEditEnabled={setEditEnabled}
        cancelButton={editEnabled ? true : false}
        handleSave={() => handleUpdateQuickTale()}
        loading={loading}
      /> */}
      <DetailsPageHeader
        mainTitle={"Visual Search Settings"}
        bgColor="#fff"
        buttonText={"Edit"}
        editEnabled={editEnabled}
        setEditEnabled={setEditEnabled}
        cancelButton={editEnabled ? true : false}
        handleSave={() => handleSaveClarifai()}
        loading={loading}
      />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          {/* <FilterSection
            handleFilterModalOpen={handleFilterModalOpen}
            filterOptions={filterOptions}
          />
          <SearchBar selected={selected} setSelected={setSelected} /> */}

          <Typography style={mainTitleStyles}>Clarifai settings</Typography>

          <Grid container style={dataContainerStyles}>
            {/*left side column*/}
            <Grid item container direction={"column"} xs>
              {/*QT Title section*/}
              <QTDetailsTextFieldWithLabelSection
                label={"Snapshots Frequency"}
                value={clarifaiData.snapshotsFrequency}
                disabled={true}
                editEnabled={editEnabled}
                select={true}
                dropdownValues={[
                  0.1, 0.3, 0.5, 0.7, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0,
                  9.0, 10,
                ]}
                onChange={(e) =>
                  setClarifaiData({
                    ...clarifaiData,
                    snapshotsFrequency: e.target.value,
                  })
                }
              />
              <QTDetailsTextFieldWithLabelSection
                label={"Display List Score"}
                value={clarifaiData.displayListScore}
                disabled={true}
                editEnabled={editEnabled}
                onChange={(e) =>
                  setClarifaiData({
                    ...clarifaiData,
                    displayListScore: e.target.value,
                  })
                }
              />
            </Grid>
            {/*right side column*/}
            <Grid item container direction={"column"} xs>
              <QTDetailsTextFieldWithLabelSection
                label={"Direct Play Score"}
                value={clarifaiData.directPlayScore}
                disabled={true}
                editEnabled={editEnabled}
                onChange={(e) =>
                  setClarifaiData({
                    ...clarifaiData,
                    directPlayScore: e.target.value,
                  })
                }
              />
              <QTDetailsTextFieldWithLabelSection
                label={"Time limit"}
                value={clarifaiData.timeLimit}
                disabled={true}
                editEnabled={editEnabled}
                onChange={(e) =>
                  setClarifaiData({
                    ...clarifaiData,
                    timeLimit: e.target.value,
                  })
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* 
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={handleFilterModalClose}
        data={[
          {
            mainOptions: filterOptions,
            setMainOptions: setFilterOptions,
            type: "text",
            title: "Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "accepted", selected: false },
              { label: "pending", selected: false },
              { label: "declined", selected: false },
            ],
          },
        ]}
      /> */}
    </Box>
  );
};

export default AdminUsersContainer;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "56px 30px",
};

const mainTitleStyles = {
  color: "#020303",
  fontSize: 23,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
  paddingTop: 30,
  paddingLeft: 20,
};
